module.exports = __webpack_public_path__ + "static/media/12UNCTAD10.b2a5fd13.jpg";